<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-sm-12 mb-3">
          <div class="card shadow">
            <div class="card-header">
              <h3>Auto Backlog</h3>
            </div>
            <div class="card-body d-flex flex-column flex-sm-row align-items-sm-end">
              <div class="row flex-grow-1">
                <div class="col-6">
                  <label class="form-control-label">Tipo *</label>
                  <multiselect
                    v-model="selectedType"
                    :options="typeOptions"
                    :custom-label="x => {return `${x.name} (Se envía de ${x.code === 'pvc' ? 'México' : 'Chihuahua'})`}"
                    placeholder="Seleccionar tipo"
                    track-by="code"
                    class="mb-4">
                  </multiselect>
                </div>
                <div class="col-6">
                  <label class="form-control-label">CEDIS *</label>
                  <multiselect
                    v-model="selectedCedis"
                    :options="cedisOptions"
                    label="cedis"
                    placeholder="Seleccionar CEDIS"
                    track-by="whsCode"
                    class="mb-4"
                    >
                  </multiselect>
                </div>
              </div>
              <div class="ml-4 mb-4 align-self-end">
                <base-button
                  @click="showTables()"
                  :disabled="!selectedType || !selectedCedis || loadingTables">
                  Ok
                  <i i class="fa fa-arrow-right ml-2"></i>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 my-3">
          <div class="card shadow">
            <div>
              <div class="d-flex align-items-center">
                <div class="card-header border-0 h4 py-4 flex-grow-1"
                     style="cursor:pointer;"
                     v-b-toggle.collapse-lastST>
                      <i class="fa fa-chevron-right mr-2 collapse-icon fa-xs"></i>
                      <span>Última solicitud de traslado </span>
                      <span v-if="lastST" class="text-muted text-sm font-italic font-weight-light">({{lastST.Comments}})</span>
                </div>
                <div class="mr-4">
                  <base-button
                    v-if="lastProduction && currentData.type.code === 'pvc'"
                    @click="print('lastProduction')"
                    size="sm"
                    type="primary"
                    icon="fa fa-print">
                  Último material a producir
                  </base-button>
                </div>
              </div>
              <b-collapse id="collapse-lastST" v-model="collapse.lastST">
                <div class="table-responsive">
                  <base-table thead-classes="thead-light" :data="tables.lastST">
                    <template #columns>
                      <th>Código</th>
                      <th>Artículo</th>
                      <th>Cantidad</th>
                    </template>
                    <template #default="{ row, index }">
                      <th>{{ row.ItemCode }}</th>
                      <th>{{ row.ItemDescription }}</th>
                      <th>{{ parseFloat(row.Quantity) }}</th>
                    </template>
                  </base-table>
                  <p v-if="!tables.lastST.length" class="text-center text-muted text-sm my-3">
                    No hay datos
                  </p>
                </div>
              </b-collapse>
            </div>
            <hr class="my-0">
            <div>
              <div class="card-header border-0 h4 py-4"
                   style="cursor:pointer;"
                   v-b-toggle.collapse-shipping>
                <i class="fa fa-chevron-right mr-2 collapse-icon fa-xs"></i>
                Envíos directos abiertos
              </div>
              <b-collapse id="collapse-shipping" v-model="collapse.directShipping">
                <div class="table-responsive">
                  <base-table thead-classes="thead-light" :data="tables.directShipping">
                    <template #columns>
                      <th>Código</th>
                      <th>Artículo</th>
                      <th>Cantidad</th>
                      <th>U_DirectShipping</th>
                    </template>
                    <template #default="{ row, index }">
                      <th>{{ row.ItemCode }}</th>
                      <th>{{ row.Dscription }}</th>
                      <th>{{parseFloat(row.SumOpenQty)}}</th>
                      <th>{{ row.U_DirectShipping }}</th>
                    </template>
                  </base-table>
                  <p v-if="!tables.directShipping.length" class="text-center text-muted text-sm my-3">
                    No hay datos
                  </p>
                </div>
              </b-collapse>
            </div>
            <hr class="my-0">
            <div>
              <div v-b-toggle.collapse-newST
                   class="card-header border-0 h4 py-4"
                   style="cursor:pointer;">
                <i class="fa fa-chevron-right mr-2 collapse-icon fa-xs"></i>
                Nueva solicitud de traslado
              </div>
              <b-collapse id="collapse-newST" v-model="collapse.newST">
                <div class="table-responsive">
                  <base-table thead-classes="thead-light" :data="tables.newST">
                    <template #columns>
                      <th></th>
                      <th>Código</th>
                      <th>Artículo</th>
                      <th>Cantidad</th>
                      <th v-if="currentData.type.code === 'pvc'">Cant. pendiente ML</th>
                      <th v-if="currentData.type.code === 'pvc'">Cant. pendiente M2</th>
                      <th></th>
                    </template>
                    <template #default="{ row, index }">
                      <th :style="highlightBg(index, 'newST')">
                        <base-button
                          @click="removeItemST(index, 'newST')"
                          size="sm"
                          type="danger"
                          icon="fa fa-trash"/>
                      </th>
                      <th :style="highlightBg(index, 'newST')">
                        {{ row.type === "master" ? row.item.MasterItemCode : row.item.ItemCode}}
                        <span v-if="row.type === 'master'" class="font-weight-light text-muted font-italic text-xs">(master)</span>
                      </th>
                      <th :style="highlightBg(index, 'newST')">
                        {{ row.item.Dscription }}
                      </th>
                      <th :style="highlightBg(index, 'newST')" >
                        <span v-if="row.type === 'pvc'">{{parseFloat(row.item.STMEX_for_this_CEDIS)}}</span>
                        <span v-else-if="row.type === 'no_pvc'">{{parseFloat(row.item.RequiredQty)}}</span>
                        <span v-else-if="row.type === 'master'">{{parseFloat(row.item.Remainder_M2)}}</span>
                      </th>
                      <th v-if="currentData.type.code === 'pvc'"
                          :style="highlightBg(index, 'newST')">
                        {{parseFloat(row.item.Remainder_ML)}}
                      </th>
                      <th v-if="currentData.type.code === 'pvc'"
                          :style="highlightBg(index, 'newST')">
                        {{ parseFloat(row.item.Remainder_M2) }}
                      </th>
                      <th :style="highlightBg(index, 'newST')">
                        <base-button
                          @click="returnToPending(row.item, index, 'newST')"
                          v-if="row.type === 'master'"
                          size="sm"
                          type="danger"
                          icon="fa fa-trash">
                        </base-button>
                      </th>
                    </template>
                  </base-table>
                  <p v-if="!tables.newST.length" class="text-center text-muted text-sm my-3">
                    No hay datos
                  </p>
                </div>
              </b-collapse>
            </div>
            <div v-if="currentData.type.code === 'pvc'">
              <hr class="my-0">
              <div class="card-header border-0 h4 py-4"
                   style="cursor:pointer;"
                   v-b-toggle.collapse-production>
                <i class="fa fa-chevron-right mr-2 collapse-icon fa-xs"></i>
                Material a producir en {{ selectedCedis ? ` ${selectedCedis.cedis}` : '' }}
              </div>
              <b-collapse id="collapse-production" v-model="collapse.production">
                <div class="table-responsive">
                  <base-table thead-classes="thead-light" :data="tables.production">
                    <template #columns>
                      <th>Código</th>
                      <th>Artículo</th>
                      <th>Master</th>
                      <th>Cantidad Pendiente ML</th>
                      <th>Cantidad M2</th>
                      <th></th>
                    </template>
                    <template #default="{ row, index }">
                      <th :style="highlightBg(index, 'production')">
                        {{ row.ItemCode }}
                      </th>
                      <th :style="highlightBg(index, 'production')">
                        {{ row.Dscription }}
                      </th>
                      <th :style="highlightBg(index, 'production')">
                        {{ row.MasterItemCode }}
                      </th>
                      <th  :style="highlightBg(index, 'production')">
                        {{ parseFloat(row.Remainder_ML) }}
                      </th>
                      <th :style="highlightBg(index, 'production')">
                        {{ parseFloat(row.Remainder_M2) }}
                      </th>
                      <th :style="highlightBg(index, 'production')">
                        <base-button
                          @click="returnToPending(row, index, 'production')"
                          icon="fa fa-trash"
                          type="danger"
                          size="sm">
                        </base-button>
                      </th>
                    </template>
                  </base-table>
                  <p v-if="!tables.production.length" class="text-center text-muted text-sm my-3">
                    No hay datos
                  </p>
                </div>
              </b-collapse>
            </div>
            <div v-if="currentData.type.code === 'pvc'">
              <hr class="my-0">
              <div class="card-header border-0 h4 py-4"
                   style="cursor:pointer;"
                   v-b-toggle.collapse-pending>
                <i class="fa fa-chevron-right mr-2 collapse-icon fa-xs"></i>
                Pendientes
              </div>
              <b-collapse id="collapse-pending" v-model="collapse.pending">
                <div class="table-responsive">
                  <table class="table tablesorter">
                    <thead class="thead-light">
                      <tr>
                          <th>Código Master</th>
                          <th>Master disponible en CEDIS</th>
                          <th>Master disponible en MEX</th>
                          <th>Cant. pendiente total M2</th>
                      </tr>
                    </thead>
                    <tbody v-for="(item, indexMaster) in tables.pending" :key="indexMaster" class="border-0">
                      <tr v-if="item.items.length" v-b-toggle="`collapse-row-${indexMaster}`" style="cursor: pointer;" class="hover-secondary">
                          <th>
                            <h2 class="m-0">
                             <span class="badge badge-pill text-body" style="cursor: text;">{{ item.MasterItemCode }}</span>
                            </h2>
                          </th>
                          <th>
                            <h2 title="Master disponible en CEDIS" class="m-0 p-0 text-body">
                              <span :class="{ 'badge-danger text-red': textCedis && textCedis.subtract === indexMaster,
                                              'badge-info': textCedis && textCedis.sum === indexMaster,
                                              'badge badge-pill': true }" >
                                  {{ parseFloat(item.StockATPMasters_this_CEDIS) }}
                              </span>
                            </h2>
                          </th>
                          <th>
                            <h2 title="Master disponible en MEX" class="m-0 p-0 text-body">
                              <span :class="{ 'badge-danger text-red': textMex && textMex.subtract === indexMaster,
                                              'badge-success': textMex && textMex.sum === indexMaster,
                                              'badge badge-pill': true }">
                                {{ parseFloat(item.StockATPMasters_MEX_for_this_CEDIS) }}
                              </span>
                            </h2>
                          </th>
                          <th>
                            <h2 title="Cant. pendiente total M2" class="m-0 p-0 text-body">
                              <span :class="{ 'badge-danger text-red': (textCedis && textCedis.subtract === indexMaster) || 
                                                                       (textMex && textMex.subtract === indexMaster),
                                              'badge-info': textCedis && textCedis.sum === indexMaster,
                                              'badge-success': textMex && textMex.sum === indexMaster,

                                              'badge badge-pill': true }">
                                {{ sumItems(item.items, 'Remainder_M2') }}
                              </span>
                            </h2>
                          </th>
                      </tr>
                      <tr v-if="item.items.length">
                        <td class="p-0 border-0" colspan="100">
                          <b-collapse :id="`collapse-row-${indexMaster}`">
                            <div class="table-responsive p-4 border-0">
                              <base-table  thead-classes="thead-light" class="border" :data="item.items">
                                <template #columns>
                                  <th>Código</th>
                                  <th>Artículo</th>
                                  <th>Cantidad ML</th>
                                  <th>Cantidad M2</th>
                                  <th class="text-center" width="10%"></th>
                                </template>
                                <template #default="{ row, index }">
                                  <th>{{ row.ItemCode }}</th>
                                  <td>{{ row.Dscription }}</td>
                                  <td>{{ parseFloat(row.Remainder_ML) }}</td>
                                  <td>{{ parseFloat(row.Remainder_M2) }}</td>
                                  <td class="text-center" width="10%">
                                    <base-button
                                      v-if="parseFloat(item.StockATPMasters_this_CEDIS) >= parseFloat(row.Remainder_M2)"
                                      @click="addToProduction(indexMaster, row, index)"
                                      size="sm"
                                      type="info">
                                     Producir artículo
                                    </base-button>
                                    <base-button
                                      v-else-if="currentData.cedis.cedis !== 'MEX' &&
                                        parseFloat(item.StockATPMasters_MEX_for_this_CEDIS) >= parseFloat(row.Remainder_M2)"
                                      @click="addToNewST(indexMaster, row, index)"
                                      size="sm"
                                      type="success">
                                     Agregar Master a ST
                                    </base-button>
                                    <span v-else class="text-muted font-weight-light font-italic text-xs">Búscale</span>
                                  </td>
                                </template>
                              </base-table>
                            </div>
                          </b-collapse>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p v-if="!tables.pending.length" class="text-center text-muted text-sm my-3">
                    No hay datos
                  </p>
                </div>
              </b-collapse>
            </div>
            <hr class="my-0">


            <div :class="['card-body d-flex', savingNewST || savingProduction ? 'justify-content-center' : 'justify-content-end']">
              <base-loader v-if="savingNewST || savingProduction" text="Generando Auto Backlog"></base-loader>
              <div 
                v-b-popover.hover.left="currentData.type.code === 'no_pvc' && currentData.cedis.cedis === 'CUU' ? 
                                          `Se creará una ST de CUU a CUU.` : 
                                        currentData.type.code === 'pvc' && currentData.cedis.cedis === 'MEX' && !tables.production.length ? 
                                          `No puedes crear una ST de MEX a MEX. Solo puedes agregar material a producir.` :
                                          null">
              <base-button
                v-if="!(savingNewST || savingProduction)"
                @click="createAutoBacklog()"
                icon="fa fa-check"
                :disabled="!autoback || 
                          (!tables.newST.length && !tables.production.length) ||
                          (currentData.type.code === 'pvc' && currentData.cedis.cedis === 'MEX' && !tables.production.length)">
                Crear
              </base-button>                
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Print Last Production Material Table -->
      <div v-if="lastProduction" id="lastProduction" hidden>
        <div class="p-4">
          <h4 class="py-3">Material a Producir en {{currentData.cedis.cedis}} <small>({{lastProduction.datetime}}) <span v-if="lastProduction.st">ST: {{lastProduction.st}}</span></small></h4>
          <base-table class="table-sm font-weight-bold" :data="tables.lastProduction">
            <template #columns class="p-8">
              <th class="border-bottom-0">Código</th>
              <th class="border-bottom-0">Artículo</th>
              <th class="border-bottom-0">Master</th>
              <th class="border-bottom-0">Cant. ML</th>
              <th class="border-bottom-0">Cant. M2</th>
            </template>
            <template #default="{ row }">
              <td><small><b>{{row.ItemCode}}</b></small></td>
              <td><small>{{row.Dscription}}</small></td>
              <td><small>{{row.MasterItemCode}}</small></td>
              <td><small>{{parseFloat(row.Remainder_ML)}}</small></td>
              <td><small>{{parseFloat(row.Remainder_M2)}}</small></td>
            </template>
          </base-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import { getAuth } from "firebase/auth";
import BaseLoader from '@/components/BaseLoader.vue';
import BaseButton from '../components/BaseButton.vue';

export default {
  components: {
    Multiselect,
    BaseLoader,
    BaseButton
  },
  data() {
    return {
      user: null,
      selectedType: null,
      selectedCedis: null,
      typeOptions: [
        {code:"pvc", name:"PVC",},
        {code:"no_pvc", name: "No PVC"}
      ],
      cedisOptions: [
        {whsCode: "CUU-02", cedis: "CUU"},
        {whsCode: "MEX-02", cedis: "MEX"},
        {whsCode: "GDL-02", cedis: "GDL"},
        {whsCode: "QRO-02", cedis: "QRO"},
        {whsCode: "MTY-02", cedis: "MTY"},
        {whsCode: "MID-02", cedis: "MID"},
      ],
      autoback: null,
      loadingTables: false,
      lastST: null,
      lastProduction: null,
      tables: {
        lastST: [],
        directShipping: [],
        newST: [],
        pending: [],
        production: [],
        lastProduction:[]
      },
      collapse:{
        lastST: false,
        directShipping: false,
        newST: false,
        pending: false,
        production: false,
      },
      currentData: {
        type: {code: null, name: null},
        cedis: {whsCode: null, cedis: null}
      },
      highlight :{
        newST: false,
        production: false
      },
      textCedis: null,
      textMex: null,
      savingNewST: false,
      savingProduction: false
    }
  },
  methods: {
    showTables(){
      this.loadingTables = true;
      Object.keys(this.tables).forEach(x => { this.tables[x] = []});
			axios.all([
        axios.get(`/api/inventory_transfer/by/cedis?cedis=${this.selectedCedis.cedis}&type=${this.selectedType.name}`),
        axios.post(`/api/autoback/${this.selectedType.code}`, { cedis: this.selectedCedis.whsCode }),
        axios.get(`api/production_backlog/by/cedis?cedis=${this.selectedCedis.cedis}`),
      ])
      .then(axios.spread((...responses) => {

        // GET Inventory Transfer by CEDIS
        if(responses[0].data.length){
          this.lastST = responses[0].data[0];
          this.tables.lastST = this.lastST.StockTransferLines;
        } else {
          this.lastST = null;
        }

        // POST Autobacklog PVC & No PVC
        this.currentData.type = this.selectedType;
        this.currentData.cedis = this.selectedCedis;

        if(this.selectedType.code === "pvc") {
          this.autoback = responses[1].data.filter(x => parseFloat(x.Missing_thisCEDIS) > 0);
          this.autoback.forEach(x => {
            if(x.U_DirectShipping){
                this.tables.directShipping.push(x);
            } else {
              if(parseFloat(x.STMEX_for_this_CEDIS) > 0){
                this.tables.newST.push({type:"pvc", item: x});
              }
              else if(parseFloat(x.STMEX_for_this_CEDIS) === 0){
                this.tables.pending.push(x);
              }
            }
          });
          this.tables.pending = this.groupByMaster(this.tables.pending);

          //GET Production Backlog by CEDIS
          if(responses[2].data){
            this.lastProduction = responses[2].data
            this.tables.lastProduction = this.lastProduction.items;
          } else {
            this.lastProduction = null;
          }
        } else if(this.selectedType.code === "no_pvc"){
          this.autoback = responses[1].data;
          this.autoback.forEach(x => {
            if(x.U_DirectShipping){
              this.tables.directShipping.push(x);
            } else {
              if(parseFloat(x.RequiredQty) > 0){
                this.tables.newST.push({type:"no_pvc", item: x});
              }
            }
          });
        }
        Object.keys(this.collapse).forEach(x => this.collapse[x] = this.tables[x].length ? true : false);
        this.loadingTables = false;
      })).catch(error => {
        console.error(error);
      });
    },
    groupByMaster(json) {
      return json.reduce((acc, currentObj) => {
        let repeatedMaster = acc.find(x => x.MasterItemCode === currentObj.MasterItemCode);

        if(repeatedMaster){
          repeatedMaster.items.push(currentObj);
        } else {
          acc.push(
            {
              MasterItemCode: currentObj.MasterItemCode,
              StockATPMasters_this_CEDIS: currentObj.StockATPMasters_this_CEDIS,
              StockATPMasters_MEX_for_this_CEDIS: currentObj.StockATPMasters_MEX_for_this_CEDIS,
              items: [currentObj]
            });
        }
        return acc;
      }, []);
    },
    addToProduction(indexMaster, item, indexItem){
      let items = this.tables.pending[indexMaster].items;
      items.splice(indexItem, 1);
      let stockCedis = this.tables.pending[indexMaster].StockATPMasters_this_CEDIS;
      this.tables.pending[indexMaster].StockATPMasters_this_CEDIS = parseFloat(stockCedis) - parseFloat(item.Remainder_M2);
      this.tables.production.push(item);
      this.collapse.production = true;
      this.highlight.production = true;
      this.textCedis = {subtract: indexMaster};
      setTimeout(() => {
        this.highlight.production = false;
        this.textCedis = null;
      }, 1000);
    },
    addToNewST(indexMaster, item, indexItem){
      let items = this.tables.pending[indexMaster].items;
      items.splice(indexItem, 1);

      let stockMex = this.tables.pending[indexMaster].StockATPMasters_MEX_for_this_CEDIS;
      this.tables.pending[indexMaster].StockATPMasters_MEX_for_this_CEDIS =  parseFloat(stockMex) - parseFloat(item.Remainder_M2);

      this.tables.newST.push({type:"master", item: item});
      this.collapse.newST = true;
      this.highlight.newST = true;
      this.textMex = {subtract : indexMaster};
      setTimeout(() => {
        this.highlight.newST = false;
        this.textMex = null;
      }, 1000);
    },
    returnToPending(item, index, table){
      let master = this.tables.pending.find(x => x.MasterItemCode === item.MasterItemCode);
      let masterIndex = this.tables.pending.findIndex(x => x.MasterItemCode === item.MasterItemCode);
      master.items.push(item);
      if(table === "production"){
        master.StockATPMasters_this_CEDIS = parseFloat(master.StockATPMasters_this_CEDIS) + parseFloat(item.Remainder_M2);
        this.textCedis = { sum: masterIndex}
      } else if (table === "newST"){
        master.StockATPMasters_MEX_for_this_CEDIS = parseFloat(master.StockATPMasters_MEX_for_this_CEDIS) + parseFloat(item.Remainder_M2);
        this.textMex = { sum: masterIndex}
      }
      this.tables[table].splice(index, 1);
      this.collapse.pending = true;
      setTimeout(() => {
        this.textCedis = null;
        this.textMex = null;
      }, 1000);
    },
    sumItems(obj, key){
      let result = obj.reduce((acc, currentObj) => {
        return acc + parseFloat(currentObj[key])
      }, 0 );
      return result;
    },
    removeItemST(index, table){
      this.tables[table].splice(index, 1);
    },
    highlightBg(index, table){
      let background = "white";
      let recent;
      if(table === "newST"){
        background = '#E2FFF3';
        recent = this.highlight.newST;
      } else if(table === "production"){
        background = '#ddfaff';
        recent = this.highlight.production;
      }
      return { background: recent && this.tables[table].length - 1 === index ? background : '',
               transition: '.5s'}
    },
    async print(elementId) {
      await this.$htmlToPaper(elementId);
    },
    createAutoBacklog(){
      console.log("🚀 ~ file: Backlog.vue:620 ~ createAutoBacklog ~ this.currentData.type.code:", this.currentData.type.code)

      // Save New ST
      if(!((this.currentData.type.code === "pvc" && this.currentData.cedis.cedis === "MEX"))) {
        
        this.savingNewST = true;

        let stockTransferLines = this.tables.newST.map((x) => {
          let quantity;
          if (x.type === 'pvc') {
            quantity = parseFloat(x.item.STMEX_for_this_CEDIS);
          } else if (x.type === 'no_pvc') {
            quantity = parseFloat(x.item.RequiredQty);
          } else if (x.type === 'master') {
            quantity = parseFloat(x.item.Remainder_M2);
          }
          return {
            "ItemCode": x.type === "master" ? x.item.MasterItemCode : x.item.ItemCode,
            "ItemDescription": x.item.Dscription,
            "Quantity": quantity,
            "U_RequestedDate": moment().format('YYYY-MM-DD'),
            "U_Type": "auto_back",
          }
        });

        let comment = `Auto_Backlog ${this.currentData.type.name} ${this.currentData.cedis.cedis} hasta ${moment().locale("es-mx").format("LLL")}`;

        let jsonST = {
        	StockTransferLines: stockTransferLines,
        	FromWarehouse: this.currentData.type.code === "pvc" ? "MEX-02" : "CUU-02",
        	ToWarehouse: `TRAN-${this.currentData.cedis.cedis}`,
        	U_Type: 5,
        	U_FinalDestWhs: this.currentData.cedis.whsCode,
        	Comments: comment,
          U_TransferRequestType: 'Autoback'
        };

        if(this.lastST){
          axios.post(`api/inventory_transfer/close?doc_entry=${this.lastST.DocEntry}`)
          .then(response => {
            console.log("🚀 ~ file: Backlog.vue:655 ~ createAutoBacklog ~ response:", response)
            setTimeout(() => {
              axios.post(`/api/inventory_transfer_requests`, jsonST)
              .then(response => {
                console.log("🚀 ~ file: Backlog.vue:659 ~ setTimeout ~ response:", response)
                if(!response.data.sl_err){
                  this.showTables()
                  this.$swal("", comment, "success");
                }
                else {
                  this.$swal("Error", response.data.sl_err.error.message.value, "error");
                  console.error("ERROR ST", response);
                }
              }).catch(error => {
                  console.error(error);
              }).finally(() => {
                this.savingNewST = false;
              });
            }, 5000);
          }).catch(error => {
            console.error(error);
          });

        }
        else{
          axios.post(`/api/inventory_transfer_requests`, jsonST)
            .then(response => {
              console.log("🚀 ~ file: Backlog.vue:659 ~ setTimeout ~ response:", response)
              if(!response.data.sl_err){
                this.showTables()
                this.$swal("", comment, "success");
              }
              else {
                this.$swal("Error", response.data.sl_err.error.message.value, "error");
                console.error("ERROR ST", response);
              }
            }).catch(error => {
                console.error(error);
            }).finally(() => {
              this.savingNewST = false;
            });
        }
        
        
      }

      //Save Production Material
      if(this.currentData.type.code === 'pvc' && this.tables.production.length){
        this.savingProduction = true;
        let jsonProdMaterial = { items: this.tables.production };
        let STDocNum = null;
        if(this.currentData.type.code === "pvc" && this.currentData.cedis.cedis === "CUU"){
          let st_items = []
          jsonProdMaterial.items.forEach(x => {
            st_items.push({
              "ItemCode": x.ItemCode,
              "ItemDescription": x.Dscription,
              "Quantity": parseFloat(x.Remainder_ML),
              "U_RequestedDate": moment().format('YYYY-MM-DD'),
              "U_Type": "material_production",
            })
          });
          
          let json_ST = {
            StockTransferLines: st_items,
            FromWarehouse: this.currentData.cedis.cedis+"-02",
            ToWarehouse: this.currentData.cedis.cedis === "CUU" ? "CUU-06":`TRAN-${this.currentData.cedis.cedis}`,
            U_Type: 4,
            U_FinalDestWhs: this.currentData.cedis.cedis,
            Comments: `Auto_Backlog material_production ${this.currentData.type.name} ${this.currentData.cedis.cedis} hasta ${moment().locale("es-mx").format("LLL")}`,
            U_TransferRequestType: 'Autoback'
          };

          axios.post(`/api/inventory_transfer_requests`, json_ST)
          .then(response => {
            if(!response.data.sl_err){
              STDocNum = response.data.DocNum
              axios.post(`api/production_backlog/create?cedis=${this.currentData.cedis.cedis}&email=${this.user.email}${STDocNum ? '&st='+STDocNum:''}`, jsonProdMaterial)
              .then(response => {
                axios.get(`api/production_backlog/by/cedis?cedis=${this.currentData.cedis.cedis}`)
                .then(response => {
                  if(response.data){
                    this.lastProduction = response.data;
                    this.tables.lastProduction = this.lastProduction.items;
                    this.showTables()
                    this.$swal("", `Material a Producir ${this.currentData.cedis.cedis} guardado`, "success");
                    setTimeout(() => this.print('lastProduction'), 1500);
                  }
                }).catch(error => {
                  console.error(error);
                });
              }).catch(error => {
                console.error(error);
              }).finally(() => {
                this.savingProduction = false;
              });
            }
            else {
              this.$swal("Error", response.data.sl_err.error.message.value, "error");
              console.error("ERROR ST", response);
            }
          }).catch(error => {
              console.error(error);
          })
        }
        else{
          console.log(`api/production_backlog/create?cedis=${this.currentData.cedis.cedis}&email=${this.user.email}`)

          axios.post(`api/production_backlog/create?cedis=${this.currentData.cedis.cedis}&email=${this.user.email}`, jsonProdMaterial)
          .then(response => {

            axios.get(`api/production_backlog/by/cedis?cedis=${this.currentData.cedis.cedis}`)
            .then(response => {
              if(response.data){
                this.lastProduction = response.data;
                this.tables.lastProduction = this.lastProduction.items;
                this.showTables()
                this.$swal("", `Material a Producir ${this.currentData.cedis.cedis} guardado`, "success");
                setTimeout(() => this.print('lastProduction'), 1500);
              }
            }).catch(error => {
              console.error(error);
            });
          }).catch(error => {
            console.error(error);
          }).finally(() => {
            this.savingProduction = false;
          });
        }
      }
    },
  },
  created() {
    this.user = getAuth().currentUser;
  },
}
</script>
<style scoped>
.collapse-icon {
  transition: 0.3s;
}
:not(.collapsed) > .collapse-icon {
    transform: rotate(90deg);
}
.hover-secondary:hover{
  background: #f7fafc;
  transition: 0.3s;
}
</style>
